import React, { FC, useEffect, useState } from 'react';
import IIconBullet from '../../../interfaces/elements/iconBullet';
import IMediaItem from '../../../interfaces/umbracoNodes/mediaItem';
import IUrlPickerItem from '../../../interfaces/umbracoNodes/urlPickerItem';
import Button from '../../base/button';
import { StyledRichText } from '../../base/richTextStyleWrapper/richTextStyleWrapper';
import { A } from '../../base/typography';
import IconBulletList from '../iconBulletList';
import * as StyledHero from './splitHero.styles';

interface Props {
	pageId: number;
	title: string;
	subTitle?: string;
	content: string;
	image: IMediaItem;
	button?: IUrlPickerItem;
	heroBulletPoints?: IIconBullet[];
}

const SplitHero: FC<Props> = ({ title, subTitle, content, image, button, heroBulletPoints }) => {
	const [showVideo, setShowVideo] = useState(false);

	useEffect(() => {
		if (image && !showVideo) {
			if (image.Src.includes('.mp4')) {
				setShowVideo(true);
			}
		}
	}, [showVideo, setShowVideo, image]);

	return (
		<StyledHero.Wrapper>
			<StyledHero.HeroColumns>
				<StyledHero.ContentColumn tablet={image ? 1 / 2 : 1}>
					<StyledHero.ContentWrapper>
						<StyledHero.HeroTitle>{title}</StyledHero.HeroTitle>
						<StyledHero.HeroSubTitle>{subTitle}</StyledHero.HeroSubTitle>
						<StyledRichText content={content} />

						{heroBulletPoints && <IconBulletList bulletList={heroBulletPoints} />}

						{button && (
							<StyledHero.ButtonWrapper>
								<A to={button.Url} target={button.Target ? button.Target : null}>
									<Button primary="true">{button.Name}</Button>
								</A>
							</StyledHero.ButtonWrapper>
						)}
					</StyledHero.ContentWrapper>
				</StyledHero.ContentColumn>
				{image && (
					<StyledHero.ImageColumn tablet={1 / 2}>
						{!showVideo && (
							<StyledHero.HeroImage image={image.Src} useCrop={false} contain hidePlaceholder />
						)}
						{showVideo && (
							<StyledHero.HeroVideo controls>
								<StyledHero.VideoSource src={image.Src} />
							</StyledHero.HeroVideo>
						)}
					</StyledHero.ImageColumn>
				)}
			</StyledHero.HeroColumns>
		</StyledHero.Wrapper>
	);
};

export default SplitHero;
